import { render, staticRenderFns } from "./CartResume.vue?vue&type=template&id=46fad33c&scoped=true&"
import script from "./CartResume.vue?vue&type=script&lang=js&"
export * from "./CartResume.vue?vue&type=script&lang=js&"
import style0 from "./CartResume.vue?vue&type=style&index=0&id=46fad33c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fad33c",
  null
  
)

export default component.exports